import { render, staticRenderFns } from "./StandView.vue?vue&type=template&id=09a562b7"
import script from "./StandView.vue?vue&type=script&lang=ts"
export * from "./StandView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports